import SubscriptionsTable from './SubscriptionsTable';

export default SubscriptionsTable;
